import { render, staticRenderFns } from "./campaign_stat.vue?vue&type=template&id=f10d87a4&scoped=true&"
import script from "./campaign_stat.vue?vue&type=script&lang=js&"
export * from "./campaign_stat.vue?vue&type=script&lang=js&"
import style0 from "./campaign_stat.vue?vue&type=style&index=0&id=f10d87a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10d87a4",
  null
  
)

export default component.exports